import { Flex, PageHeader } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { PublishedProjectMutableGuard } from '@/features/authentication/_components/PublishedProjectMutableGuard';
import { useProject } from '@/features/project/_hooks/project';
import { ProjectsPageDynamicLink } from '@/features/project/projects/_components/ProjectsPageDynamicLink';
import { ProjectNameTitle } from '@/features/project/projects/project-detail/_components/ProjectNameTitle';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectActionsButton } from './ProjectActionsButton';
import { ProjectDisplayGuard } from './ProjectDisplayGuard';

export const ProjectDetailsPageHeader: FC = () => {
  const { t } = useTranslation();
  const { id } = useId();

  const _project = useProject(id);

  return (
    <PageHeader
      title={<ProjectNameTitle />}
      breadcrumbs={[
        { title: <ProjectsPageDynamicLink /> },
        { title: t('project-details-page') },
      ]}
      buttons={
        <ProjectDisplayGuard>
          <Flex gap={8}>
            {/* <PublishedProjectMutableGuard>
              <ProjectAndDiffSwitcher />
              {features?.workflow && (
                <WorkflowSiderButton name={project.data?.name} />
              )}
            </PublishedProjectMutableGuard> */}
            <PublishedProjectMutableGuard
              additionalAccessibleProjectRole={[
                'view',
                'edit',
                'privilege',
                'view-all-privilege',
              ]}
            >
              {/* {features?.comment && (
                <CommentSiderButton
                  peopleInChargeIds={project.data?.peopleInChargeIds}
                  filteredOrganizationFiscalYear={project.data?.fiscalYear}
                />
              )} */}
            </PublishedProjectMutableGuard>
            {/* <AiChatSiderButton /> */}
            <ProjectResourceGuard onlyEdit>
              <PublishedProjectMutableGuard>
                <ProjectActionsButton />
              </PublishedProjectMutableGuard>
            </ProjectResourceGuard>
          </Flex>
        </ProjectDisplayGuard>
      }
    />
  );
};
